import { callBackendApi } from "../../../../../../components/service/axios";

export async function getReviewTasks(payload) {
  return await callBackendApi("get", "bff/review-tasks", {}, payload);
}

export async function postReviewTasks({ appId, payload }) {
  return await callBackendApi("post", `bff/applications/${appId}/review-tasks`, payload, null);
}

export async function reassignReviewTask({ taskId, assignee, comments }) {
  return await callBackendApi(
    "put",
    `bff/review-tasks/${taskId}/reassignment`,
    {
      assignee: assignee,
      comment: comments,
    },
    null,
    false
  );
}
